const Pause = ({ width = "18", height = "18", fill = "#111928" }) => (
  <svg
    width={width}
    height={height}
    fill={fill}
    viewBox="0 0 320 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M48 63.1C39.16 63.1 32 71.16 32 80v352C32 440.8 39.16 448 48 448S64 440.8 64 432v-352C64 71.16 56.84 63.1 48 63.1zM272 63.1c-8.836 0-16 7.162-16 16v352c0 8.836 7.164 16 16 16s16-7.164 16-16v-352C288 71.16 280.8 63.1 272 63.1z" />
  </svg>
);

export default Pause;
